module.exports = __webpack_public_path__ + "static/media/tree-planting.c36429b8.jpg";